import {
    Button,
    Chip,
    CircularProgress,
    Container,
    Divider,
    List,
    ListItem,
    Stack,
    Typography,
    Box,
    useMediaQuery
  } from "@mui/material";
  import React, { useState } from "react";
  import Header from "../../components/header/header";  
  import ProfileDetails from "../../components/profile/profile";  
  import { grey } from "@mui/material/colors";
  import { useTheme } from "@mui/material/styles";
  const Profile = () => {
    const theme = useTheme();
  const [loading, setLoading] = useState(false);
  
  
    return (
      <React.Fragment>
        <Header  />
        <Container
          sx={{ marginY: "35px" }}
          maxWidth="lg"
          disableGutters={useMediaQuery(theme.breakpoints.up("lg"))}
        >
          
          <Box marginY={4}>
            {/* Header */}
            
           
             <ProfileDetails></ProfileDetails>
              
            
          </Box>
        </Container>
      </React.Fragment>
    );
  
}
  export default Profile;
  